






import {Component, Vue} from "vue-property-decorator";
import {GuideSaveCompanyReq} from "@/model/Guide";
import {setGuideSaveCompany, getGuideDetail, sendVerifyEmail, getFlowCount} from "@/services/api";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {defaultTimezone, getTimezones} from "@/services/config";

@Component({
  components: {
    'yc-aside': YcAside,
    'yc-header': YcHeader
  },
})
export default class AccountSettings extends Vue {
  // 时区列表
  public timezones = getTimezones();
  public activeTab = 'email';
  public guideSaveCompanyReq: GuideSaveCompanyReq = {
    defaultSenderName: '',
    defaultSenderEmail: '',
    country: '',
    province: '',
    city: '',
    address: '',
    zipCode: '',
    site: '',
    name: '',
    timezone: '',
    orderAttributionMethod:'OPEN_CLICK',
    orderAttributionWindow:5,
    
  }
  public oldEmail = '';
  public count: number|null = null;

  get rules() {
    const maxLen = this.$t('views.accountsettings.text_957f5ea64e0d80fd') as string;
    return {
      defaultSenderName:[{ required: true, message: this.$t('views.accountsettings.text_8bf78f9351659ed8') as string, trigger: 'blur' }, {max: 200, message: maxLen, trigger: 'blur' }],
      defaultSenderEmail:[
        {required: true, message: this.$t('views.accountsettings.text_8bf78f93516553d1') as string, trigger: 'blur' },
        {max: 200, message: maxLen, trigger: 'blur' },
        {
          trigger: "blur",
          validator: (rule: any, value: any, callback: any) => {
            if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
              callback(new Error(this.$t('views.accountsettings.text_8bf78f9351656b63') as string));
            } else {
              callback();
            }
          }
        }
        ],
      name:[{max: 200, message: maxLen, trigger: 'blur' }],
      site:[{max: 200, message: maxLen, trigger: 'blur' }],
      city:[{max: 200, message: maxLen, trigger: 'blur' }],
      province:[{max: 200, message: maxLen, trigger: 'blur' }],
      address:[{max: 200, message: maxLen, trigger: 'blur' }],
      orderAttributionMethod:[{ required: true, message: this.$t('views.accountsettings.text_8bf7900962e95f52') as string, trigger: 'blur' },]
    };
  }

  created(): void {
    // this.getGuideDetail();
    window.location.href = '/cartsee-new/account'
  }

  /**
   * 添加品牌信息
   */
  setGuideSaveCompany(): void {
    const companyForm: any = this.$refs.companyForm;
    companyForm.validate((valid: boolean) => {
      if (valid) {
        setGuideSaveCompany(this.guideSaveCompanyReq, true).then(res => {
          this.$message.success(this.$t('views.accountsettings.text_4fdd5b586210529f'));
          this.activeTab = 'email';
          localStorage.setItem('timezone', this.guideSaveCompanyReq.timezone|| defaultTimezone);
          if(this.oldEmail !== this.guideSaveCompanyReq.defaultSenderEmail) {
            this.$router.push(`/email/verify?email=${this.guideSaveCompanyReq.defaultSenderEmail}`)
            sendVerifyEmail({email: this.guideSaveCompanyReq.defaultSenderEmail}).then(res => {
              this.$message.success(this.$t('views.accountsettings.text_90ae4ef653d19001'))
            })
          }
        })
      } else {
        return false;
      }
    });
  }

  /**
   * 获取向导进度接口
   */
  async getGuideDetail(): Promise<void> {
    await getGuideDetail({},true).then(res => {
      this.guideSaveCompanyReq = res.data.data.companyInfo;
      this.guideSaveCompanyReq.timezone = this.guideSaveCompanyReq.timezone || defaultTimezone;
      this.oldEmail = res.data.data.companyInfo.defaultSenderEmail;
    })
    if (this.$store.state.flowCount !== null) {
      this.count = this.$store.state.flowCount;
    } else {
      getFlowCount({}, true).then(res => {
        this.count = res.data.data;
      })
    }
  }

}
